import { render } from "./modalalert.vue?vue&type=template&id=adfccc86"
import script from "./modalalert.vue?vue&type=script&lang=js"
export * from "./modalalert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__